import { Nameable } from "../common/ComponentBehavioural";
import {Identifier} from "../common/Identifier";
import {ProjectSegmentFilter} from "./ProjectSegmentFilter";
import {Nullable} from "../common/Nullable";
import {Module} from "../common/Module";
import {isPrivileged} from "../../config/Privileges";
import {ProjectAreaName} from "./Project";
import {SoftDeletable} from "../common/SoftDeletable";
import {OptionType} from "../../components/form/SearchableSelect";



export const ProjectCommissionStateModule: Module = {
    identifier: "commission_state" ,
    isPrivileged: ( authUser, privilege ) =>
        isPrivileged(
            authUser,
            ProjectAreaName,
            ProjectCommissionStateModule.identifier,
            privilege
        ),
};

/**
 * api route to fetch commission state for select components
 * mostly used with fetchSelectOptions
 *
 * @see fetchSelectOptions
 */
export function projectCommissionStateSelectRoute( commissionStateFilter: ProjectCommissionStateFilter ): string {

    return `projects/commission_states/select/${ commissionStateFilter.forProjects ? 1 : 0 }/${ commissionStateFilter.forProjectStage ? 1 : 0 }/${ commissionStateFilter.forProjectStagePhase ? 1 : 0 }/${ commissionStateFilter.forContractors ? 1 : 0 }/${ commissionStateFilter.forProjectTasks ? 1 : 0 }`;
}

/**
 * id model for Project commission state
 */
export interface ProjectCommissionStateId {
    stateId: Identifier<number>
}

export interface ProjectCommissionStateFilter extends ProjectSegmentFilter {

}

export interface ProjectCommissionSelectOption extends OptionType {
    includeInBilling: boolean
}

/**
 * the state of the commission
 */
export interface ProjectCommissionState extends ProjectCommissionStateId, Nameable, ProjectCommissionStateFilter, SoftDeletable {
    includeInBilling: boolean
}

/**
 * form request commission state
 *
 * Important:
 * backend api does not allow stateId equals null on update
 */
export interface ProjectCommissionStateRequest extends Omit< ProjectCommissionState, 'stateId' | 'isDeleted' > {
    stateId: Nullable< number >
}

export interface ProjectCommissionStateRequestProp {
    projectCommissionStateReq: ProjectCommissionStateRequest
}